import { SignupFlow } from 'corgi-types';

export const getIsReferralSignUpFlow = (userFlow: SignupFlow) => userFlow === SignupFlow.Referral;
export const getIsCartSignUpFlow = (userFlow: SignupFlow) => userFlow === SignupFlow.Cart;
